import { IChannelRecording } from './channelRecording';
import { Inherit, InheritCell, InheritGrid, InheritHead, Scope } from './ChannelSettings.styled';

interface Props {
  label: string;
  channelName?: string;
  recording?: IChannelRecording;
}

// Read-only view of the channel-level recording config inside the program drawer.
export const InheritedRecording = ({ label, channelName, recording }: Props) => {
  if (!channelName) return null;

  const cells: [string, string][] = recording
    ? [
        ['RECORDING MACHINE', recording.machine || '—'],
        ['SOURCE FOLDER', recording.source || '—'],
        ['FOLDER NAME', recording.folder || '—'],
        ['ADS AUTOMATION', recording.ads ? 'On' : 'Off'],
      ]
    : [];

  return (
    <Inherit>
      <InheritHead>
        <Scope>{label} level</Scope>
        <span className="t">Recording configuration inherited from {channelName}</span>
        <span className="w">Read-only here — edit it in {label} Settings on the Program Setup list.</span>
      </InheritHead>
      {recording ? (
        <InheritGrid>
          {cells.map(([key, value]) => (
            <InheritCell key={key}>
              <span className="k">{key}</span>
              <span className="v ps-mono">{value}</span>
            </InheritCell>
          ))}
        </InheritGrid>
      ) : (
        <span className="w" style={{ fontSize: 12, color: 'var(--ink-4)' }}>
          No {label.toLowerCase()} settings yet. Set them in {label} Settings once this program is created.
        </span>
      )}
    </Inherit>
  );
};
